module.exports = "../dist/img/img_1-33.d571.jpg";